import React, { useState } from "react";
import "../../components/table/table.css";
import {
  FaExclamationTriangle,
  FaMinusCircle,
  FaPlusCircle,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DateConvertor from "../../components/dateConvertor/DateConvertor";
import toTitleCase from "../../lib/titleCase/TitleCase";
import TruncateWord from "../../lib/truncateWords/TruncateWord";

const IssueSection = ({ last_five_issues }) => {
  const [showTable, setShowTable] = useState(true);
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/support/RaiseIssue");
  };

  return (
    <div className="leave-wrapper">
      <div className="leave-header">
        <div className="leave-title">
          <FaExclamationTriangle className="leave-icon" />
          <span>Last 10 Issues</span>
        </div>
        <div className="leave-actions">
          <button className="view-all-btn" onClick={handleClick}>
            View All
          </button>
          <button
            className="icon-toggle-btn"
            onClick={() => setShowTable(!showTable)}
          >
            {showTable ? <FaMinusCircle /> : <FaPlusCircle />}
          </button>
        </div>
      </div>

      {showTable && (
        <div
          className="table-container"
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <table className="leave-table">
            <thead>
              <tr>
                <th
                  className="text-muted fs-6 text-nowrap pe-2"
                  style={{ width: "20%" }}
                >
                  Ticket No
                </th>
                <th
                  className="text-muted fs-6 text-nowrap pe-2"
                  style={{ width: "15%" }}
                >
                  Priority
                </th>
                <th
                  className="text-muted fs-6 text-nowrap pe-2"
                  style={{ width: "20%" }}
                >
                  Project Name
                </th>
                <th
                  className="text-muted fs-6 text-nowrap pe-2"
                  style={{ width: "20%" }}
                >
                  Created By
                </th>
                <th
                  className="text-muted fs-6 text-nowrap pe-2"
                  style={{ width: "20%" }}
                >
                  Created At
                </th>
                <th
                  className="text-muted fs-6 text-nowrap"
                  style={{ width: "15%" }}
                >
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {last_five_issues?.length > 0 ? (
                last_five_issues.map((issue) => (
                  <tr key={issue.incident_no}>
                    <td
                      className="fw-medium text-dark text-truncate pe-2"
                      style={{ maxWidth: "120px" }}
                    >
                      {issue.incident_no}
                    </td>
                    <td className="fw-medium text-dark text-nowrap pe-2">
                      {issue.priority_mode}
                    </td>
                    <td
                      className="fw-medium text-dark text-truncate pe-2"
                      style={{ maxWidth: "120px" }}
                    >
                      {issue.project__project_name}
                    </td>
                    <td
                      className="fw-medium text-dark text-truncate pe-2"
                      style={{ maxWidth: "120px" }}
                    >
                      {toTitleCase(issue.created_by__username)}
                    </td>
                    <td className="text-muted fs-6 text-nowrap pe-2">
                      {<DateConvertor inputDate={issue.created_at} />}
                    </td>
                    <td>
                      <span
                        className={`badge rounded-pill ${
                          issue.status === "COMPLETED"
                            ? "bg-success"
                            : "bg-warning"
                        } text-nowrap`}
                      >
                        {issue.status}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-muted fs-6 text-center py-3">
                    No issues available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div style={{ flex: "0 0 10px" }}></div>
        </div>
      )}
    </div>
  );
};

export default IssueSection;
